module.exports = __webpack_public_path__ + "static/img/left-right.205a434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-right.png
// module id = I04s
// module chunks = 2